const API_URL = 'http://localhost:5001/api/auth';

//
// Tipos
//

export interface UsuarioRegistro {
  nombre: string;
  email: string;
  password: string;
  edad: number;
  peso: number;
  altura: number;
  rol?: string;
}

export interface LoginPayload {
  email: string;
  password: string;
}

export interface LoginResponse {
  id: string;
  email: string;
  rol: string;
  token: string;
}

//
// Funciones de autenticación
//

// 📝 Registro de usuario
export async function register(data: UsuarioRegistro): Promise<LoginResponse> {
  const res = await fetch(`${API_URL}/register`, {
    method: 'POST',
    headers: { 'Content-Type': 'application/json' },
    body: JSON.stringify(data),
  });

  if (!res.ok) {
    const error = await res.json();
    throw new Error(error?.error || '❌ Error al registrar usuario');
  }

  return await res.json();
}

// 🔐 Login de usuario
export async function login(email: string, password: string): Promise<LoginResponse> {
  const payload: LoginPayload = { email, password };

  const res = await fetch(`${API_URL}/login`, {
    method: 'POST',
    headers: { 'Content-Type': 'application/json' },
    body: JSON.stringify(payload),
  });

  if (!res.ok) {
    const error = await res.json();
    throw new Error(error?.error || '❌ Credenciales incorrectas');
  }

  return await res.json();
}
